var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortIconActiveUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.284 8.02246C11.5768 7.72988 11.5773 7.25499 11.285 6.96191L8.53594 4.20802C8.39527 4.06719 8.20378 3.98828 8.00469 3.98828C7.80581 3.98841 7.61501 4.06733 7.47442 4.20797L4.72539 6.96191C4.4328 7.25504 4.43327 7.72983 4.72639 8.02246C5.01951 8.3151 5.4943 8.31463 5.78691 8.02148L7.08421 6.72248C7.14719 6.65942 7.25497 6.70402 7.25497 6.79315L7.25497 11.2288C7.25499 11.643 7.59077 11.9788 8.00497 11.9788C8.41917 11.9788 8.75495 11.643 8.75497 11.2288L8.75497 6.79255C8.75497 6.70341 8.86279 6.65881 8.92576 6.72192L10.2225 8.02148C10.5151 8.31463 10.9908 8.3151 11.284 8.02246Z",
    fill: "#0B5CFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIconActiveUp);
export default __webpack_public_path__ + "static/media/sort-icon-active-up.3fc7a51efb6907dc0e6b685685b2f87e.svg";
export { ForwardRef as ReactComponent };